import React, { useState } from 'react'
import Icon from '../Icon/Icon'
import ColumnType from './Column.interface'
import useStyles from '../Table/useStyles'

interface PropsInterface {
    className?: string
    columns: ColumnType[];
    handleSorting?(accessor, sortOrder): any;
    'data-testid'?: string;
}

/**
 *
 */
const TableHead = ({
    className,
    columns,
    handleSorting,
    'data-testid': dataTestId = 'table-head'
}: PropsInterface): JSX.Element => {
    const styles = useStyles({ color: 'neutral-50' })

    const [sortField, setSortField] = useState('')
    const [order, setOrder] = useState('asc')

    const handleSortingChange = (accessor) => {
        const sortOrder = accessor === sortField && order === 'asc' ? 'desc' : 'asc'
        setSortField(accessor)
        setOrder(sortOrder)
        handleSorting(accessor, sortOrder)
    }

    return (
        <thead className={className || styles.tHead} data-testid={dataTestId}>
            <tr data-testid={`${dataTestId}-row`}>
                {columns.map(({ label, accessor, sortable, width }, i) => {
                    let icon = ''
                    if (sortable) {
                        if (sortField === accessor && order === 'asc') {
                            icon = 'down-alt'
                        } else if (sortField === accessor && order === 'desc') {
                            icon = 'up-alt'
                        } else {
                            icon = 'sort-light'
                        }
                    }
                    return (
                        <th
                            key={accessor}
                            onClick={() => sortable ? handleSortingChange(accessor) : null}
                            style={{ width, cursor: sortable ? 'pointer' : undefined }}
                            className={sortable ? 'th--sortable' : ''}
                            data-testid={`${dataTestId}-data-${i}`}
                        >
                            {label}
                            {icon &&
                                <Icon
                                    name={icon}
                                    color='currentColor'
                                    size={16}
                                    style={{ marginLeft: 5 }}
                                    className='table-head--icon'
                                    data-testid={`${dataTestId}-data-${i}-icon`}
                                />
                            }
                        </th>
                    )
                })}
            </tr>
        </thead>
    )
}
export default TableHead
